import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  img: string;
  alt: string;
  name: string;
  title: string;
  description: string;
  city: string;
}

export const BoardofCommitteePictures: RouteInfo[] = [
  {
    img: '../../../assets/images/Brd_Photos/B_Gutierrez.png',
    alt: 'Bob Gutierrez Picture',
    name: 'Bob Gutierrez',
    title: 'Chairman ',
    description: 'BG Strategies',
    city: 'Stockton, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/V_Corona.png',
    alt: 'Veronica Corona Picture',
    name: 'Veronica Corona',
    title: 'Vice Chairwoman ',
    description: 'CM Cleaning Solutions Inc.',
    city: 'Los Angeles, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/J_Canete.jpeg',
    alt: 'Julian Cañete Picture',
    name: 'Julian Cañete',
    title: 'President & CEO ',
    description: 'California Hispanic Chambers of Commerce',
    city: 'Sacramento, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/J_Chamberlin.png',
    alt: 'Jenny Chamberlain Picture',
    name: 'Jenny Chamberlain ',
    title: 'Secretary (At-Large) ',
    description: 'Sonoma County Board of Supervisors',
    city: 'Santa Rosa, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/D_King.png',
    alt: 'Dennis King Picture',
    name: 'Dennis King',
    title: 'Parliamentarian (At-Large)',
    description: 'Hispanic Chamber of Commerce of Silicon Valley',
    city: 'San Jose, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/L_Blanco-Jimenez.png',
    alt: 'Lisa Blanco - Jimenez Picture',
    name: 'Lisa Blanco - Jimenez',
    title: 'CHCC General Counsel',
    description: 'Neumiller & Beardslee',
    city: 'Stockton, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/S_Ayala.png',
    alt: 'Sal Ayala Picture',
    name: 'Sal Ayala',
    title: 'Inland Empire Region Chair ',
    description: 'Uniko Media Group',
    city: 'Riverside, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/R_Hernandez.png',
    alt: 'Raul Hernandez Picture',
    name: 'Raul Hernandez',
    title: 'Treasurer  (At-Large)',
    description: 'Hood & Strong, LLP.',
    city: 'San Francisco, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/M_Limon.png',
    alt: 'Mike Limon Picture',
    name: 'Mike Limon',
    title: 'Southern Region Chair ',
    description: 'Orange County Educational Arts Academy',
    city: 'Santa Ana, CA',
  },

  {
    img: '../../../assets/images/Brd_Photos/C_Solorzano.png',
    alt: 'Carlos Solorzano Picture',
    name: 'Carlos Solorzano',
    title: 'Northern Region Chair ',
    description: 'Multi Vision Latina, LLC.',
    city: 'San Francisco, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/J_Tamsi.png',
    alt: 'Jay Tamsi Picture',
    name: 'Jay Tamsi',
    title: 'Central Region Chair',
    description: 'Kern County Hispanic Chamber of Commerce',
    city: 'Bakersfield, CA',
  },
];
export const BoardofDirectorPictures: RouteInfo[] = [
  {
    img: '../../../assets/images/Brd_Photos/S_Aguilar.png',
    alt: 'Sylvester Aguilar Picture',
    name: 'Sylvester Aguilar',
    title: 'Central Region Director',
    description: 'Port of Stockton',
    city: 'Stockton, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/J_Baisa.png',
    alt: 'Julio Baisa Picture',
    name: 'Julio Baisa',
    title: 'Northern Region Director',
    description: 'Camara de Comercio Agrupacion del Norte de CA',
    city: 'San Jose, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/L_Callejas.png',
    alt: 'Leo Callejas Picture',
    name: 'Leo Callejas',
    title: 'Northern Region Director',
    description: 'DigitalTrack Digital Marketing',
    city: 'Fairfield, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/A_Cubas.png',
    alt: 'Ana Cubas Picture',
    name: 'Ana Cubas',
    title: 'At-Large Director',
    description: 'Mariposa Consulting',
    city: 'Los Angeles, CA',
  },

  {
    img: '../../../assets/images/Brd_Photos/S_Durate.png',
    alt: 'Sylvia Duarte Picture',
    name: 'Sylvia Duarte',
    title: 'Inland Empire Region Director',
    description: 'Moonlite Sounds',
    city: 'Palmdale Valley, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/B_Butler-Garcia.png',
    alt: 'Brenna Butler - Garcia Picture',
    name: 'Brenna Butler - Garcia',
    title: 'At-Large Director',
    description: 'A.G. Spanos Companies',
    city: 'Stockton, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/M_Gomez.png',
    alt: 'Marcus Gomez Picture',
    name: 'Marcus Gomez',
    title: 'Central Region ',
    description: 'California Clothing Recyclers',
    city: 'Sacramento, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/E_Marquez.png',
    alt: 'Eddie Marquez Picture',
    name: 'Eddie Marquez',
    title: 'Southern Region Director',
    description: 'Construction Trade Association',
    city: 'Orange County, CA',
  },

  {
    img: '../../../assets/images/Brd_Photos/G_Mello.png',
    alt: 'Gabriella Mello Picture',
    name: 'Gabriella Mello',
    title: 'At-Large Director',
    description: 'Citizens Business Bank',
    city: 'Bakersfield, CA',
  },

  {
    img: '../../../assets/images/Brd_Photos/RichardSandoval.png',
    alt: 'Richard Sandoval Picture',
    name: 'Richard Sandoval',
    title: 'Inland Empire Region Director',
    description: 'Hispanic Lifestyle',
    city: 'Menifee, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/R_Villa.png',
    alt: 'Ricardo Villa Picture',
    name: 'Ricardo Villa',
    title: 'Southern Region Director',
    description: 'SimpleTime Payroll',
    city: 'San Diego, CA',
  },

  {
    img: '../../../assets/images/Brd_Photos/K_Macias.png',
    alt: 'Ken Macias Picture',
    name: 'Ken Macias',
    title: 'Chairman Emeritus Director',
    description: 'Macias Consulting Group',
    city: 'Sacramento, CA',
  },
];
@Component({
    selector: 'app-board-of-directors',
    templateUrl: './board-of-directors.component.html',
    styleUrls: ['./board-of-directors.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BoardOfDirectorsComponent implements OnInit {
  mainTitle = 'Board of Directors';
  committees: any = [];
  directors: any = [];

  constructor() {}

  ngOnInit(): void {
    this.committees = BoardofCommitteePictures.filter((committee) => committee);
    this.directors = BoardofDirectorPictures.filter((director) => director);
  }
}
